// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-RdtRhqAn","foot_link":"foot_link-3oOvoYQr clearfix","fk_l":"fk_l-Fdlau09p","link":"link-23rokSjx","copyright":"copyright-Or3neBQF"};